import baseAPI from "@/http";

const router = "api/geral/porte";

export const porteAPI = {
  get: id => baseAPI.get(`${router}/${id}`),
  list: () => baseAPI.get(`${router}`)
};
